var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"hiq-culture-magazine__list"},_vm._l((_vm.articles),function(article){return _c('li',{key:article.id,attrs:{"data-link-box":""}},[_c('Article',{attrs:{"article":article}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }